import { z } from 'zod';
// Billing History Status
export var BillingHistoryStatusEnum;
(function (BillingHistoryStatusEnum) {
    BillingHistoryStatusEnum["PENDING"] = "PENDING";
    BillingHistoryStatusEnum["PAID"] = "PAID";
    BillingHistoryStatusEnum["FAILED"] = "FAILED";
    BillingHistoryStatusEnum["REFUNDED"] = "REFUNDED";
    BillingHistoryStatusEnum["CANCELLED"] = "CANCELLED";
})(BillingHistoryStatusEnum || (BillingHistoryStatusEnum = {}));
export const BillingHistoryStatusSchema = z.nativeEnum(BillingHistoryStatusEnum);
// Subscription Status
export var SubscriptionStatusEnum;
(function (SubscriptionStatusEnum) {
    SubscriptionStatusEnum["ACTIVE"] = "ACTIVE";
    SubscriptionStatusEnum["INACTIVE"] = "INACTIVE";
    SubscriptionStatusEnum["CANCELLED"] = "CANCELLED";
    SubscriptionStatusEnum["EXPIRED"] = "EXPIRED";
})(SubscriptionStatusEnum || (SubscriptionStatusEnum = {}));
export const SubscriptionStatusSchema = z.nativeEnum(SubscriptionStatusEnum);
// Recurring Plan Status
export var RecurringPlanStatusEnum;
(function (RecurringPlanStatusEnum) {
    RecurringPlanStatusEnum["ACTIVE"] = "ACTIVE";
    RecurringPlanStatusEnum["INACTIVE"] = "INACTIVE";
    RecurringPlanStatusEnum["CANCELLED"] = "CANCELLED";
    RecurringPlanStatusEnum["EXPIRED"] = "EXPIRED";
})(RecurringPlanStatusEnum || (RecurringPlanStatusEnum = {}));
export const RecurringPlanStatusSchema = z.nativeEnum(RecurringPlanStatusEnum);
// Billing Interval
export var BillingIntervalEnum;
(function (BillingIntervalEnum) {
    BillingIntervalEnum["DAILY"] = "DAILY";
    BillingIntervalEnum["WEEKLY"] = "WEEKLY";
    BillingIntervalEnum["MONTHLY"] = "MONTHLY";
    BillingIntervalEnum["YEARLY"] = "YEARLY";
})(BillingIntervalEnum || (BillingIntervalEnum = {}));
export const BillingIntervalSchema = z.nativeEnum(BillingIntervalEnum);
// Billing Cycle Anchor
export var BillingCycleAnchorEnum;
(function (BillingCycleAnchorEnum) {
    BillingCycleAnchorEnum["SIGNUP_DATE"] = "SIGNUP_DATE";
    BillingCycleAnchorEnum["FIRST_OF_MONTH"] = "FIRST_OF_MONTH";
    BillingCycleAnchorEnum["CUSTOM"] = "CUSTOM";
})(BillingCycleAnchorEnum || (BillingCycleAnchorEnum = {}));
export const BillingCycleAnchorSchema = z.nativeEnum(BillingCycleAnchorEnum);
